import _slicedToArray from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["limit", "offset"];
import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useEffect, useState } from "react";
import { date, localStorage } from "@catchoftheday/utilities";
import { useRecentlyViewedProductsLazyQuery } from "@personalisation/generated/graphql";
export var LOCAL_STORAGE_KEY = "recently-viewed-products";
export var FETCHED_PRODUCTS_TTL_IN_MINUTES = 60;
export var MAX_PERSISTED_PRODUCTS = 30;

var filterOutAdultProducts = function filterOutAdultProducts(products) {
  return products.filter(function (product) {
    return !product.adult;
  });
};

var persistPayloadToLocalStorage = function persistPayloadToLocalStorage(payload) {
  var prevPayload = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(_objectSpread(_objectSpread({}, prevPayload), payload)));
};

export var recordProductView = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var product, _ref$limit, limit, _ref3, _ref3$products, savedProducts, uniqueProducts;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            product = _ref.product, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? MAX_PERSISTED_PRODUCTS : _ref$limit;
            _ref3 = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}"), _ref3$products = _ref3.products, savedProducts = _ref3$products === void 0 ? [] : _ref3$products;
            uniqueProducts = filterOutAdultProducts(_toConsumableArray(new Map([product].concat(_toConsumableArray(savedProducts)).slice(0, limit).map(function (product) {
              return [product.id, product];
            })).values()));
            persistPayloadToLocalStorage({
              products: uniqueProducts
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function recordProductView(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var useRecentlyViewedProducts = function useRecentlyViewedProducts(_ref4) {
  var _ref4$limit = _ref4.limit,
      limit = _ref4$limit === void 0 ? MAX_PERSISTED_PRODUCTS : _ref4$limit,
      _ref4$offset = _ref4.offset,
      offset = _ref4$offset === void 0 ? 0 : _ref4$offset,
      variables = _objectWithoutProperties(_ref4, _excluded);

  var _useState = useState(null),
      products = _useState[0],
      setProducts = _useState[1];

  var _useRecentlyViewedPro = useRecentlyViewedProductsLazyQuery(),
      _useRecentlyViewedPro2 = _slicedToArray(_useRecentlyViewedPro, 2),
      fetchProducts = _useRecentlyViewedPro2[0],
      _useRecentlyViewedPro3 = _useRecentlyViewedPro2[1],
      error = _useRecentlyViewedPro3.error,
      loading = _useRecentlyViewedPro3.loading;

  var getProducts = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref6, savedProducts, lastFetched;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref6 = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}"), savedProducts = _ref6.products, lastFetched = _ref6.lastFetched;

            if (!(savedProducts && lastFetched && date.addMinutes(new Date(lastFetched), FETCHED_PRODUCTS_TTL_IN_MINUTES) > new Date())) {
              _context2.next = 4;
              break;
            }

            setProducts(savedProducts.slice(0, limit));
            return _context2.abrupt("return");

          case 4:
            _context2.next = 6;
            return fetchProducts({
              variables: _objectSpread({
                limit: limit,
                offset: offset
              }, variables),
              onCompleted: function onCompleted(_ref7) {
                var products = _ref7.recentlyViewed.products;
                var fetchedProducts = filterOutAdultProducts(products);
                persistPayloadToLocalStorage(_objectSpread(_objectSpread({}, products.length ? {
                  products: fetchedProducts
                } : {}), {}, {
                  // products: products.length ? products : savedProducts,
                  lastFetched: new Date().toISOString()
                }));
                setProducts(fetchedProducts);
              }
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [limit, offset, fetchProducts]);
  useEffect(function () {
    getProducts();
  }, [getProducts]);
  return {
    products: products,
    error: error,
    loading: loading
  };
};